import { render, staticRenderFns } from "./DialogPrompt.vue?vue&type=template&id=a0ea4006"
import script from "./DialogPrompt.vue?vue&type=script&lang=js"
export * from "./DialogPrompt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/myskilliz_new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a0ea4006')) {
      api.createRecord('a0ea4006', component.options)
    } else {
      api.reload('a0ea4006', component.options)
    }
    module.hot.accept("./DialogPrompt.vue?vue&type=template&id=a0ea4006", function () {
      api.rerender('a0ea4006', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/theme/DialogPrompt.vue"
export default component.exports